const config = {
  "secretKey": "$Hj7aF#k9l*D@v!3G",
  "numberOfRows": 100,
  "authMethod": "JWT",
   //"endPoint": "https://pwbi-internal.dev.local/MillAI_BE",
  //  "endPoint": `https://${window.location.host}/MillAI_BE`, 
  //  "endPoint": "https://www.nasa.millada.sk/MillAI_BE",
  "endPoint": "https://millada-test.millennium.sk/MillAI_BE",
  //"endPoint": "https://localhost:7237",
  "subDir" : "/",
  "imgAllowed": false,
  "msgReviewsAllowed" : true,
  "jwtAllowed": true,
  "adAllowed" : false,
  "adConfig": {
    "clientId": "f0e36a15-2456-42c6-ac8c-bf32528c9029",
    "authority":"https://login.microsoftonline.com/organizations",
    //"redirectUri": "https://localhost:3000", 
    //"redirectUri": "https://www.nasa.millada.sk",
     "redirectUri": `https://${window.location.host}`, 
    "scopes": ["User.Read"/*, "Group.Read.All"*/]
  }
}
export default config;